module.exports = __webpack_public_path__ + "img/Weapon_76.978e530c.png";